<template>
  <div id="Dispute">
    <div class="Textpara">
      <p class="Textaction">常见问题</p>
      <p class="Textaction">Q：我要怎么申请家长监督未成年人账号？</p>
      <p class="TextInfo">A：首先下载页面的申请表，根据提示填写完成，再把相关资料发送至kefu@tsapk.com</p>
      <p class="Textaction">Q：什么时间可以申请？</p>
      <p class="TextInfo">A：随时可以申请，我司收到申请后将在三个工作日内进行电话反馈。</p>
      <p class="Textaction">Q：申请监控的账号有什么要求？</p>
      <p class="TextInfo">A：账号所属人必须未满18周岁。</p>
      <p class="Textaction">Q：申请成功后会对被监控人的账号进行哪些处理？</p>
      <p class="TextInfo">A：我们会在确认您提供的信息无误后，您可以选择以下方案中的方法对被监控人账号进行处理</p>
      <p class="TextInfo">1、限制帐号上线时间段。</p>
      <p class="TextInfo">2、限制帐号每周上线的天数。</p>
      <p class="TextInfo">3、根据家长要求对帐号进行自定义限制。</p>
      <p class="TextInfo">4、对该账号每周的游戏时间进行统计（本周总共在游戏内玩了多久）。</p>
      <p class="Textaction">Q：我提交申请后，多久可以审核完毕开始监控？</p>
      <p class="TextInfo">A：我们会以最快的速度进行核实处理，如果由于您提供的材料不同，任何步骤出现疑问有疑问，我们都会与您联系。</p>
      <p class="Textaction">Q：我提交申请成功后，如果需要取消监督如何操作？</p>
      <p class="TextInfo">1、您可以通过上门或传真方式提供申请监督时的相关信息，申请解除监督。</p>
      <p class="TextInfo">2、被监护账号所属人年满18周岁可提供申请监督时的相关信息进行申请结束监督。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Dispute"
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';
#Dispute{
  width:100%;
  paddingPage();
  cardStyle();
}
</style>



// WEBPACK FOOTER //
// src/components/About/Dispute.vue